import z from 'zod';
import { AllCharLabelSchema, SubjectSchema } from '../common/schemas';
import {
  DBNoteHrefSchema,
  DBNoteIsExternalLinkSchema,
  DBNoteKeySchema,
  DBNoteLabelSchema,
  DBNoteNoteIdSchema,
  DBNoteShortLabelSchema,
  NoteHrefSchema,
  NoteIdSchema,
  NoteIsExternalLinkSchema,
  NoteCodeSchema,
  NoteLabelSchema,
  NoteShortLabelSchema,
} from '../notes/schemas';

/**
 * Shared & Helper Schemas
 */

export const DBNotesCategoryNotesEntrySchema = z.object({
  href: z.lazy(() => DBNoteHrefSchema),
  isExternalLink: z.lazy(() => DBNoteIsExternalLinkSchema),
  key: z.lazy(() => DBNoteKeySchema),
  label: z.lazy(() => DBNoteLabelSchema),
  noteId: z.lazy(() => DBNoteNoteIdSchema),
  shortLabel: z.lazy(() => DBNoteShortLabelSchema),
});

export const NotesCategoryNotesEntrySchema = z.object({
  id: z.lazy(() => NoteIdSchema),
  subject: z.lazy(() => SubjectSchema),
  categoryCode: z.lazy(() => NotesCategoryCodeSchema),
  code: z.lazy(() => NoteCodeSchema),
  label: z.lazy(() => NoteLabelSchema),
  shortLabel: z.lazy(() => NoteShortLabelSchema),
  href: z.lazy(() => NoteHrefSchema),
  isExternalLink: z.lazy(() => NoteIsExternalLinkSchema),
});

/**
 * DB Schemas
 */

export const DBNotesCategorySubjectSchema = SubjectSchema;
export const DBNotesCategoryCategorySchema = z.string().regex(/^[a-zA-Z0-9]{4}$/);
export const DBNotesCategoryLabelSchema = AllCharLabelSchema.min(1).max(64);
export const DBNotesCategoryNotesSchema = z.array(DBNotesCategoryNotesEntrySchema);
export const DBNotesCategoryShortLabelSchema = AllCharLabelSchema.min(1).max(16);

export const DBNotesCategorySchema = z.object({
  subject: DBNotesCategorySubjectSchema,
  category: DBNotesCategoryCategorySchema,
  label: DBNotesCategoryLabelSchema,
  notes: DBNotesCategoryNotesSchema,
  shortLabel: DBNotesCategoryShortLabelSchema,
});

/**
 * Client Schemas
 */

export const NotesCategoryIdSchema = z.string().brand<'NotesCategoryId'>();
export const NotesCategorySubjectSchema = DBNotesCategorySubjectSchema;
export const NotesCategoryCodeSchema = DBNotesCategoryCategorySchema;
export const NotesCategoryLabelSchema = DBNotesCategoryLabelSchema;
export const NotesCategoryNotesSchema = z.array(NotesCategoryNotesEntrySchema);
export const NotesCategoryShortLabelSchema = DBNotesCategoryShortLabelSchema;

export const NotesCategorySchema = z.object({
  id: NotesCategoryIdSchema.meta({ title: 'Category ID' }),
  subject: NotesCategorySubjectSchema.meta({ title: 'Subject' }),
  code: NotesCategoryCodeSchema.meta({ title: 'Category code' }),
  label: NotesCategoryLabelSchema.meta({ title: 'Label' }),
  notes: NotesCategoryNotesSchema.default([]).meta({ title: 'Notes' }),
  shortLabel: NotesCategoryShortLabelSchema.meta({ title: 'Short label' }),
});
